import { addRegionToLauncherUrl, resolveClgUrl } from '@/hooks/use-promotion-launcher/utils';
import type { LauncherUrlResolutionContext } from '@/utils/url/launcher-url';
import { appendEmbeddedQueryParam } from '@/logic/game-shell/shell-bridge';
import { useStore } from '@/store/store';
import { getGameLaunchNavigationTarget } from '@/utils/url/game-launch-navigation-target';

export type PromotionGameLaunchContext = {
    isMobile: boolean;
    isXsellWrapper: boolean;
    isAndroidWrapper: boolean;
    isDesktop: boolean;
    addGameWindow: (gameWindow: Window) => void;
    region: string | undefined;
    launcherResolution: LauncherUrlResolutionContext;
};

/**
 * Opens game URLs using the same resolution and window rules as usePromotionLauncher.
 */
export const launchGameWindow = (url: string, ctx: PromotionGameLaunchContext): void => {
    const openEmbeddedGame = useStore.getState().embeddedGame.open;
    const launcherUrl = resolveClgUrl(url, ctx.launcherResolution);
    const resolvedUrl = addRegionToLauncherUrl(launcherUrl, ctx.region);

    if (ctx.isMobile && !ctx.isAndroidWrapper && !ctx.isXsellWrapper) {
        window.location.href = resolvedUrl;
        return;
    }

    if (ctx.launcherResolution.shouldUseSameDomainLauncher && ctx.isDesktop) {
        openEmbeddedGame(appendEmbeddedQueryParam(resolvedUrl));
        return;
    }

    const width = 1280;
    const height = 720;
    const left = Math.round((screen.width - width) / 2);
    const top = Math.round((screen.height - height) / 2);
    const target = getGameLaunchNavigationTarget(resolvedUrl, ctx.isMobile);
    const gameWindow = window.open(
        resolvedUrl,
        target,
        `width=${width},height=${height},left=${left},top=${top},menubar=no,toolbar=no,location=no,status=no`
    );
    if (gameWindow) {
        ctx.addGameWindow(gameWindow);
    }
};

// Backward compatible alias while callers migrate.
export const launchPromotionGameWindow = launchGameWindow;
